import { useEffect } from 'react';

import ProductImage from '@assets/png/product.png';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { withStyles } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { IProduct } from '@models/Product.model';

import Rolling from '@assets/gif/rolling.gif';

import {
  CheckCircle,
  UncheckCircle,
} from '@pages/Products/components/AddEquipmentModal/components/components.styles';
import {
  LoadingImg,
  LoadingText,
  LoadMore,
} from '@pages/Products/components/ListProducts/ListProducts.styles';
import { ListProductsLoading } from '@pages/Products/components/ListProducts/loading/ListProducts.loading';
import { useInView } from 'react-intersection-observer';
import {
  Container,
  Image,
  Label,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Trh,
} from './ListProductsWithToggle.styles';

type Wrap<T> = T;

const BlueCheckbox = withStyles({
  root: {
    color: blue[300],
    '&$checked': {
      color: blue,
    },
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

interface ListProductsProps {
  data?: IProduct[];
  total?: number;
  isLoading: boolean;
  loadMore: () => void;
  dataSelected: IProduct[];
  updateDataSelected: (productRequest?: IProduct[]) => void;
  hasMore?: boolean;
}

const ListProductsWithToggle = ({
  data,
  isLoading,
  hasMore,
  dataSelected,
  loadMore,
  updateDataSelected,
}: Wrap<ListProductsProps>) => {
  const { ref, inView } = useInView();
  useEffect(() => {
    if (inView && hasMore) loadMore();
  }, [inView, hasMore]);
  if (isLoading) {
    return <ListProductsLoading />;
  }
  if (!data) {
    return <div />;
  }
  return (
    <Container>
      <Table>
        <Thead>
          <Trh>
            <Th width={7}>
              <FormControlLabel
                control={
                  <BlueCheckbox
                    icon={<UncheckCircle />}
                    checkedIcon={<CheckCircle />}
                    name="checkedH"
                  />
                }
                label=""
                checked={
                  data.length > 0 &&
                  data.every(i =>
                    dataSelected.map(selected => selected).includes(i),
                  )
                }
                onClick={() => {
                  updateDataSelected(data);
                }}
              />
            </Th>
            <Th width={45}>Product Name</Th>
            <Th width={18}>Model #</Th>
            <Th width={30}>Manufacturer</Th>
          </Trh>
        </Thead>
        <Tbody>
          {data.map(item => (
            <Tr key={JSON.stringify(item)}>
              <Td width={7} isToggle>
                <FormControlLabel
                  control={
                    <BlueCheckbox
                      icon={<UncheckCircle />}
                      checkedIcon={<CheckCircle />}
                      name="checkedH"
                    />
                  }
                  label=""
                  checked={
                    dataSelected.find(selected => selected.id === item.id) !==
                    undefined
                  }
                  onClick={() => {
                    updateDataSelected([item]);
                  }}
                />
              </Td>
              <Td width={45}>
                <Label>
                  {item.imageUrl ? (
                    <Image src={item.imageUrl} alt="equipment" />
                  ) : (
                    <Image
                      className="defaultImage"
                      src={ProductImage}
                      alt="equipment"
                    />
                  )}
                  {item.name}
                </Label>
              </Td>
              <Td width={18}>{item.model}</Td>
              <Td width={30}>
                {item.manufacturer.name ? item.manufacturer.name : ''}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <LoadMore ref={ref}>
        {hasMore ? (
          <LoadMore>
            <LoadingText>Loading more</LoadingText>
            <LoadingImg src={Rolling} alt="loading" />
          </LoadMore>
        ) : (
          <div />
        )}
      </LoadMore>
    </Container>
  );
};

export { ListProductsWithToggle };
